import React, { useMemo } from "react"
import PropTypes from "prop-types"
import colours from "../../../styles/colours"
import style from "./Button.module.css"

const Button = props => {
  const {
    label,
    title,
    isSmall,
    isLarge,
    onPress,
    disabled,
    contained,
    outlined,
    backgroundColour,
    // outlineColour,
    colour,
    customClass,
    buttonStyle,
  } = props

  const border = outlined ? `1px solid ${colour}` : "none"
  const backgroundColor = contained ? backgroundColour : "transparent"

  return (
    <button
      title={title}
      onClick={onPress}
      disabled={disabled}
      className={[style.button, customClass].join(" ")}
      style={{ ...buttonStyle, backgroundColor, color: colour, border }}
    >
      {label.toUpperCase()}
    </button>
  )
}

Button.propTypes = {
  label: PropTypes.string.isRequired,
  colour: PropTypes.string.isRequired,
  title: PropTypes.string,
  onPress: PropTypes.func,

  isSmall: PropTypes.bool,
  isLarge: PropTypes.bool,

  contained: PropTypes.bool,
  outlined: PropTypes.bool,

  //   icon: PropTypes.string,
  disabled: PropTypes.bool,
  customClass: PropTypes.string,
}

Button.defaultProps = {
  colour: colours.green[50],
  backgroundColour: colours.green[5],
  contained: true,
  isSmall: false,
}

export default Button

// const buttonStyles = {
//   cyan: {
//     contained: {
//       color: "#FFF",
//       background: COLOURS.cyan.gradientY,
//       hover: "transform: scale(1.04);",
//     },
//     outlined: {
//       color: COLOURS.cyan[5],
//       background: "#FFF",
//       borderColor: colours.cyan.gradientX,
//       hover: "transform: scale(1.04);",
//     },
//     default: {
//       color: COLOURS.cyan[5],
//       background: "#FFF",
//       hover: "transform: scale(1.04);",
//     },
//   },
// }

// const styleKey = props.contained
//   ? "contained"
//   : outlined
//   ? "outlined"
//   : "default"

//   const StyledButton = styled.button`
// font-size: ${isSmall ? "14px" : isLarge ? "22px" : "16px"};
// background: ${contained ? backgroundColour : "transparent"};
// color: ${colour};
// ${isFullWidth && "width: 100%;"}
// padding: ${isSmall ? 8 : 12}px ${isSmall ? 16 : 24}px;
// border-radius: 4px;
// border-style: ${outlined ? "solid" : "none"};
// border-width: ${outlined ? "1px" : "0"};
// border-color: ${outlined ? outlineColour : "none"};
// transition: all 0.3s ease;
// :disabled {
//   opacity: 0;
//   cursor: default;
// }
// :hover {
//   color: ${colours.green[60]};
//   background: ${colours.green[20]};
// }
// `
